var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.workbookHasPermission('field_plotHelper'))?_c('div',{staticClass:"timeline-helper-outter"},[_c('r-standard-icon',{staticClass:"helper-icon",class:{
			warn: _vm.theme === 'warn',
			clickable: _vm.clickable === true,
		},attrs:{"icon":_vm.displayIcon,"color":_vm.iconThemeColor},on:{"click":function($event){return _vm.$emit('click')},"pointerdown":function($event){return _vm.$emit('pointerdown')}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }